import React, { useContext, useEffect } from "react";
import { Modal } from "antd";
import { useState } from "react";
import ModalHeaderLayout from "../../../layouts/ModalHeaderLayout";
import UserContext from "../../../Context/UserContext";
import axios from "axios";
import { apiUrl } from "../../../config";
import { useTranslation } from "react-i18next";

function BodyTypeModal({
  modalOpen,
  setModalOpen,
  selectedRow,
  allData,
  rule,
  setRefreshPage,
  refreshPage
}) {
  const { t } = useTranslation();
  const username = process.env.REACT_APP_USERNAME;
  const password = process.env.REACT_APP_SECRET_KEY;

  const [formData, setFormData] = useState({
    max_consecutive_production_periods: "",
    description: "",
  });

  useEffect(() => {
    if (selectedRow && rule === "changeOrder") {
      setFormData({
        max_consecutive_production_periods: selectedRow.max_consecutive_production_periods || "",
        description: selectedRow.description || "",
      });
    } else {
      setFormData({
        max_consecutive_production_periods: "",
        description: "",
      });

    }
  }, [selectedRow, modalOpen]);

  // ZORUNLU ALAN UYARILARI İÇİN ERROR STATE VE SAĞLAM BOŞLUK KONTROLÜ
  const [errors, setErrors] = useState({});
  const isEmptyValue = (v) => {
    if (v === null || v === undefined) return true;
    if (typeof v === "string") return v.trim() === "";
    return false;
  };
  useEffect(() => {
    if (modalOpen) {
      setErrors({});
    }
  }, [modalOpen, rule, selectedRow]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors((prev) => ({ ...prev, [e.target.name]: undefined }));
    }
  };

  // SUBMIT ÖNCESİ DOĞRULAMA
  const validateForm = () => {
    const errs = {};
    if (isEmptyValue(formData.description)) {
      errs.description = `${t("constraints.bodyType")} ${t("constraints.isRequired")}`;
    }
    if (isEmptyValue(formData.max_consecutive_production_periods)) {
      errs.max_consecutive_production_periods = `${t("constraints.maxConsecutiveProductionPeriods")} ${t("constraints.isRequired")}`;
    }
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errs = validateForm();
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    const requestMethod = rule === "changeOrder" ? axios.put : axios.post;
    let requestData;
    if (rule === "changeOrder") {
      requestData = { ...formData, id: selectedRow.id };
    }
    if (rule === "newOrder") {
      requestData = formData;
    }

    requestMethod(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/addBodyMaterialType`,
      requestData, {
      headers: {
        Authorization: `Basic ${btoa(`${username}:${password}`)}`
      }
    }).then(res => {
      if (res.status === 200) {
        setFormData({
          max_consecutive_production_periods: selectedRow.max_consecutive_production_periods,
          description: selectedRow.description,
        });
        setErrors({}); // BAŞARILI SUBMIT SONRASI HATALARI TEMİZLE
        setModalOpen(false)
        setRefreshPage(!refreshPage)
      }
    })
      .catch(err => console.log(err))
  }
  return (
    <Modal
      title=<ModalHeaderLayout title={rule === "changeOrder" ? t("constraints.changeBodyType") : t("constraints.addBodyType")} />
      open={modalOpen}
      footer={null}
      onOk={() => setModalOpen(false)}
      onCancel={() => {
        setModalOpen(false);
        setErrors({}); // KAPATIRKEN HATALARI TEMİZLE
      }}
      centered
      width={600}
      className="w-100 mb-40"
    >
      <form className='bg-surface p-4 rounded-2xl shadow-2xl' onSubmit={handleSubmit}>

        <div className='grid laptop:grid-cols-2 desktop:grid-cols-3 largeDesktop:grid-cols-4 gap-7 min-w-max'>
          <div>
            <label htmlFor="description">{t("constraints.bodyType")}</label>
            <input onChange={(e) => handleChange(e)} type="text" name="description" value={formData.description} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.description && <div className="text-red-600 text-xs mt-1">{errors.description}</div>}
          </div>
          <div>
            <label htmlFor="max_consecutive_production_periods">{t("constraints.maxConsecutiveProductionPeriods")}:</label>
            <input onChange={(e) => handleChange(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="max_consecutive_production_periods" value={formData.max_consecutive_production_periods} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.max_consecutive_production_periods && <div className="text-red-600 text-xs mt-1">{errors.max_consecutive_production_periods}</div>}
          </div>
        </div>
        <div>
          <button type="submit" className="bg-smartopt hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-10 w-full">{t("singularParameters.submit")}</button>

        </div>


      </form>
    </Modal>
  );
};

export default BodyTypeModal;

